module.exports = __webpack_public_path__ + "img/cigarette.41729119.svg";